import { getLocationService, updateScheduleService, getLocationByIdService, updateLocationService } from '../storeServices/locationService'

export default {
	namespaced: true,
	state: {
		locations: [],
		selectedLocation: null,
		updateStatusOptions: [
			{ text: '1. Cita', value: '1. Cita' },
			{ text: 'Not Apply - selfinspection', value: 'Not Apply - selfinspection' },
		],
		actionType: null,
		locationCount: 0,
		toggleAssigned: false,
		showModal: false,
		showModalType: null,
		modalSize: 'lg',
		checkValidation: false,
		scheduleForm: null,
		locationForm: null,
	},
	getters: {
	},
	mutations: {
		toggleAssignedLead(state, payload) {
			state.toggleAssigned = payload
		},
		setScheduleForm(state, payload) {
			state.scheduleForm = payload
		},
		setLocationForm(state, payload) {
			state.locationForm = payload
		},
		toggleValidation(state, payload) {
			state.checkValidation = payload
		},
		setSelectedLocation(state, payload) {
			state.selectedLocation = payload
		},
		setModalSize(state, payload) {
			state.modalSize = payload
		},
		setLocations(state, payload) {
			state.locations = payload.items
			state.locationCount = payload.meta.totalItems
		},
		setActionType(state, payload) {
			state.actionType = payload
		},
		updateLeadData(state, payload) {
			const index = state.locations.findIndex(lead => lead.id === payload.id)
			state.locations.splice(index, 1)
		},
		replaceLead(state, { lead, index }) {
			const asd = state.locations.map((item, i) => {
				if (i == index) {
					return lead
				} else {
					item
				}
			})
			state.locations = asd
		},
		deleteAssignedLead(state, { lead, index = null }) {
			if (!index) {
				const index = state.locations.findIndex(x => x.id == lead.id)
				if (index != -1) {
					state.locations.splice(index, 1)
				}
			} else {
				state.locations.splice(index, 1)
			}
		},
		toggleModal(state, payload) {
			const { value, type } = payload
			if (value) {
				if (type === 'manage-schedule') {
					state.modalSize = 'xl'
				} else {
					state.modalSize = 'lg'
				}
				state.showModalType = type
			}
			state.showModal = value
			
		},
	},
	actions: {
		async getLocations({ state, commit, rootState }, payload) {
			const { actionType } = state
			let paginated = undefined, options = undefined
			if(payload !== undefined){
				paginated = payload.paginated
				options = payload.options
			}
			const { date, selectedStatus, selectedCompany, searchInput, pageQuantity, selectedTypeFilter, selectedUser,actualPage } = rootState.tableFilters
			try {
				const serviceResponse = await getLocationService({ searchInput, status: selectedStatus, company: selectedCompany, date, type: actionType, limit: pageQuantity, page: actualPage, filterType: selectedTypeFilter, userFilter: selectedUser, paginated })
				console.log(serviceResponse)
				if(!options){
					commit('setLocations', serviceResponse.data)
				}
				return serviceResponse
			} catch (e) {
				return e
			}
		},
		async getLocationById({ state, commit, rootState }, payload) {
			const { selectedLocation } = state
			const serviceResponse = await getLocationByIdService({ locationId: selectedLocation.id })
			commit('setSelectedLocation', serviceResponse.data)
			return serviceResponse
		},
		async updateSchedules({ state, commit }, payload) {
			const lead = state.selectedLocation
			const updateScheduleObject = state.scheduleForm.map(schedule => {
				let deleted
				if (!schedule.wasAdded && !schedule.hasSchedule) {
					deleted = true
				}
				if (schedule.wasAdded && !schedule.hasSchedule) { return false }
				return {
					id: schedule.id,
					isDeleted: deleted,
					morningDisponibility: schedule.morningDisponibility.toString(),
					eveningDisponibility: schedule.eveningDisponibility.toString(),
					initialTime: schedule.initialTime,
					lunchTime: schedule.lunchTime,
					finalTime: schedule.finalTime,
					dayOfTheWeekId: schedule.dayOfTheWeek,
				}
			}).filter(item => item)
			console.log(updateScheduleObject)
			const serviceResponse = await updateScheduleService({ locationId: lead.id, updateScheduleObject })
			return serviceResponse
		},
		async updateLocations({ state, commit, dispatch }) {
			const location = state.selectedLocation
			const updateLocationObject = {
				address: location.address,
				name: location.name,
				quiterId: parseInt(location.quiterId),
				effectiveStartDate: location.effectiveStartDate,
				effectiveStartTime: location.effectiveStartTime,
				cityName: 'Santiago',//location.city,
				regionName: 'Región Metropolitana de Santiago',//location.region,
				contactPhone: location.contactPhone,
				contactEmail: location.contactEmail,
				googleMapUrl: location.googleMapUrl,
				state: location.state,
				type: location.type
			}
			const serviceResponse = await updateLocationService({ locationId: location.id, updateLocationObject })
			dispatch('getLocations')
			return serviceResponse
		},
	},
}
